import { type AxiosResponse } from 'axios';

import { get, post, put } from '@utilities';
import { IncentivesPercentageShare } from '@containers/incentives/sharesEditor/constants';
import { TeamWiseIncentives } from '@containers/incentives/teamWiseIncentives/constants';

export const fetchIncentivesPercentageShares = async (): Promise<AxiosResponse<IncentivesPercentageShare>> =>
	await get('incentives/team-wise-share');
export const updateIncentivesPercentageShares = async (body: IncentivesPercentageShare): Promise<AxiosResponse> =>
	await put('incentives/team-wise-share', body);
export const getTeamWiseIncentives = async (body: { offset: number; pageSize: number }): Promise<AxiosResponse<{ incentives: TeamWiseIncentives[]; totalRecords: number }>> =>
	await post('incentives/team-wise', body);
export const getTeamWiseIncentivesByProjectId = async (projectId: number): Promise<AxiosResponse<TeamWiseIncentives>> =>
	await get(`incentives/team-wise/${projectId}`);
